import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { resetPassword } from "../api/authApi";
import "./Auth.css";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setError(false);
    try {
      await resetPassword(token, password);
      setMsg("Password reset successfully!");
    } catch (err) {
      setMsg("Invalid or expired token.");
      setError(true);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Reset Password</h2>
        <form onSubmit={handleSubmit} className="auth-form">
          <label>New Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit" className="auth-btn">
            Reset Password
          </button>
        </form>
        {msg && (
          <p className={`auth-msg ${error ? "error" : "success"}`}>{msg}</p>
        )}
      </div>
    </div>
  );
}
